import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as jwt from 'jsonwebtoken';
import { storeFrontAuthActions } from '../store/store-front-auth';

export function TokenLogin(): JSX.Element {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  dispatch(storeFrontAuthActions.login(token as string));

  const payload = jwt.decode(token as string) as jwt.JwtPayload;
  const timeUntilTokenExpires: number = (payload.exp! - payload.iat!) * 1000;

  const handler = setTimeout(() => {
    dispatch(storeFrontAuthActions.logout());
  }, timeUntilTokenExpires);

  useEffect(() => {
    navigate('', { replace: true });

    return () => clearTimeout(handler);
  }, [navigate, handler]);

  return <div>Redirecting...</div>;
}
